import React, { useState } from "react";
import * as style from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";

const NewVariantCategoryLevel = ({ categories, onCategorySelect }) => {
  const defaultCategory = categories.find(category => category?.title === "26 cm") || categories[0];
  
  const [activeCategoryId, setActiveCategoryId] = useState(defaultCategory?._id);

  const handleCategoryClick = (categoryId) => {
    setActiveCategoryId(categoryId);
    onCategorySelect(categoryId);
  };

  categories.sort((a, b) => {
    const getNumber = (title) => {
      const match = title.match(/\d+/);
      return match ? parseInt(match[0]) : 0;
    };

    const numA = getNumber(a.title);
    const numB = getNumber(b.title);

    return numA - numB;
  });
  
  return (
    <>
      <div className={style.sizesContainer}>
        <ul className={style.list}>
          {categories?.map((category) => (
            <li
              key={category._id}
              className={`${style.singleCell} ${activeCategoryId === category._id ? style.active : ""} ${category.variantIcon ? style.img : ""}`}
              onClick={() => handleCategoryClick(category._id)}
            >
              {category.variantIcon ? (
                <>
                  <img width={90} height={25} srcSet={getImagePath(category.variantIcon, true)} alt={category.variantIcon?.alt} />
                </>
              ) : (
                category.title
              )}
            </li>
          ))}
        </ul>
      </div>
      {categories
        .filter((cat) => cat.children && cat.children.length > 1)
        .map((category) => (
          activeCategoryId === category._id && (
            <NewVariantCategoryLevel
              key={category._id}
              categories={category.children}
              onCategorySelect={onCategorySelect}
            />
          )
        ))}
    </>
  );
};

export default NewVariantCategoryLevel;
